import createInstance from '../http';
import config from '@/const/config';
const { request } = createInstance(config.cartBaseUrl);

export default {
  // 查询销售人员客户列表接口
  querySalespersonCustomerList: params => request.get(`/api/share-mall-gateway-salesperson/1.0.0/querySalespersonCustomerList`, { params }),
  // 选择代客下单客户接口
  chooseOrderingBehalfOfCustomer: params => request.post(`/api/share-mall-gateway-salesperson/1.0.0/chooseOrderingBehalfOfCustomer`, params),
  // 获取订单分享信息
  getOrderShareInfo: params => request.get(`/api/share-mall-gateway-share/1.0/getOrderShareInfo`, { params }),
};
